import { Haptics, ImpactStyle } from "@capacitor/haptics";

/**
 * Haptisk kvittering.
 *
 * Ett hakk per verdi i hjulene, et tydelig utslag på første trykk på
 * handlingsknappen, et tyngre når rapporten er laget. Å dra et hjul uten
 * kvittering betyr at man må se på det, og poenget er at man ser på boksen.
 *
 * MERK: Safari på iOS har ingen vibrasjons-API. I hjemskjerm-webappen finnes
 * haptikken derfor ikke på iPhone — den kommer først når appen kjører som
 * binærfil gjennom Capacitor. På Android virker den i begge. Dette er en
 * reell mangel mot docs/12-ui-feltapp.md i webversjonen.
 */

let enabled = true;

export function setHapticsEnabled(v: boolean): void {
  enabled = v;
}

export function notch(): void {
  if (!enabled) return;
  void Haptics.selectionChanged().catch(() => undefined);
}

export function tap(): void {
  if (!enabled) return;
  void Haptics.impact({ style: ImpactStyle.Light }).catch(() => undefined);
}

export function confirm(): void {
  if (!enabled) return;
  void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => undefined);
}

export function heavy(): void {
  if (!enabled) return;
  void Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => undefined);
}
